// Kept independent of HTTP/auth modules so logout can drain writes without an
// auth-store → HTTP-client import cycle. Network requests are never awaited here.
let writes: Promise<unknown> = Promise.resolve();

export async function drainInventoryWrites(): Promise<void> {
  await writes;
}

export async function commitInventoryWrite(callback: () => Promise<unknown>): Promise<void> {
  const pending = writes.then(callback);
  writes = pending.catch(() => undefined);
  await pending;
}
